<div class="wrapper">
  <div class="dialog-header">
    {{ 'display_fiat_currency' | translate }}
    <div class="onact96">
      <i class="fi-x" (click)="dialogRef.close()"></i>
    </div>
  </div>
  <div class="dialog-body">
    {{ 'this_will_change_your_default_fiat_display_currency_you_can' | translate }}
    <cs-select [(value)]="currentFiat" [options]="fiatOptions"></cs-select>
    <cs-button [label]="'save' | translate" [size]="'large'" (buttonClick)="onSave()"></cs-button>
  </div>
</div>
